module.exports = __webpack_public_path__ + "static/media/presentaciones.7222898a.svg";